export enum PlotType {
    FullTriangularMatrix = "fullTriangularMatrix",
    FullMirroredMatrix = "fullMirroredMatrix",
    ParameterResponseMatrix = "parameterResponseMatrix",
}

export const MAX_NUMBER_OF_PARAMETERS_IN_MATRIX = 500; // To avoid performance issues
